/* import __COLOCATED_TEMPLATE__ from './cases-pill.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type IntlService from 'ember-intl/services/intl';
import { IntegrationState } from 'embercom/objects/standalone/constants';

interface StampConfig {
  label: string;
  color: 'yellow' | 'gray' | 'green' | 'red';
  icon?: InterfaceIconName;
}

interface Args {}

export default class SalesforceSetupCasesPill extends Component<Args> {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare intl: IntlService;

  get salesforceConfig() {
    return this.finStandaloneService.salesforceConfig!;
  }

  get stampConfig(): StampConfig {
    switch (this.salesforceConfig.status) {
      case IntegrationState.Enabled:
        return {
          label: this.intl.t('standalone.salesforce.setup.live'),
          color: 'green',
          icon: 'rounded-check',
        };
      case IntegrationState.Paused:
        return {
          label: this.intl.t('standalone.salesforce.setup.paused'),
          color: 'yellow',
          icon: 'pause',
        };
      default:
        return {
          label: this.intl.t('standalone.salesforce.setup.not-setup'),
          color: 'gray',
        };
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Salesforce::Setup::CasesPill': typeof SalesforceSetupCasesPill;
    'standalone/salesforce/setup/cases-pill': typeof SalesforceSetupCasesPill;
  }
}
